// Safari roundRect polyfill
const hasCanvasRenderingContext2D = typeof CanvasRenderingContext2D !== 'undefined';

if (hasCanvasRenderingContext2D && !CanvasRenderingContext2D?.prototype?.roundRect) {
  CanvasRenderingContext2D.prototype.roundRect = function (x, y, width, height, radii) {
    if (typeof radii === 'number') {
      radii = [radii, radii, radii, radii];
    } else if (radii.length === 1) {
      radii = [radii[0], radii[0], radii[0], radii[0]];
    } else if (radii.length === 2) {
      radii = [radii[0], radii[1], radii[0], radii[1]];
    } else if (radii.length === 3) {
      radii = [radii[0], radii[1], radii[2], radii[1]];
    }

    const [topLeft, topRight, bottomRight, bottomLeft] = radii;

    this.beginPath();
    this.moveTo(x + topLeft, y);
    this.lineTo(x + width - topRight, y);
    this.arcTo(x + width, y, x + width, y + topRight, topRight);
    this.lineTo(x + width, y + height - bottomRight);
    this.arcTo(x + width, y + height, x + width - bottomRight, y + height, bottomRight);
    this.lineTo(x + bottomLeft, y + height);
    this.arcTo(x, y + height, x, y + height - bottomLeft, bottomLeft);
    this.lineTo(x, y + topLeft);
    this.arcTo(x, y, x + topLeft, y, topLeft);
    this.closePath();
  };
}
